import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { sendMessage, getMessages } from "@/lib/api";
import { toast } from "sonner";
import "@/App.css";

const SenderPage = () => {
  const navigate = useNavigate();
  const [role, setRole] = useState("field");
  const [name, setName] = useState("");
  const [body, setBody] = useState("");
  const [urgent, setUrgent] = useState(false);
  const [sending, setSending] = useState(false);
  const [broadcasts, setBroadcasts] = useState([]);

  const loadBroadcasts = () => getMessages("outbound").then((d) => setBroadcasts(d.items || [])).catch(() => {});
  useEffect(() => {
    loadBroadcasts();
    const t = setInterval(loadBroadcasts, 8000);
    return () => clearInterval(t);
  }, []);

  const send = async () => {
    if (!body.trim()) { toast.error("Type a message."); return; }
    setSending(true);
    try {
      await sendMessage({ sender_role: role, target: "command", body, priority: urgent ? "urgent" : "normal", sender_name: name || (role === "field" ? "Field Officer" : "Citizen") });
      toast.success("Sent to the Command Centre.");
      setBody(""); setUrgent(false);
    } catch (e) {
      toast.error("Could not send.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="App">
      <div className="sender-wrap">
        <button className="btn btn-ghost back-btn" onClick={() => navigate("/")} data-testid="sender-back">
          <i className="fa-solid fa-arrow-left" /> Command dashboard
        </button>

        <div className="sender-card">
          <div className="sender-head">
            <div className="brand-mark"><i className="fa-solid fa-mobile-screen-button" /></div>
            <div>
              <h2>Mobile App · Demo Sender</h2>
              <p>Stand-in for the Field Officer &amp; Public apps. Send a message to the Command Centre.</p>
            </div>
          </div>

          <div className="comms-targets">
            <button className={role === "field" ? "on" : ""} onClick={() => setRole("field")} data-testid="sender-role-field">
              <i className="fa-solid fa-user-shield" /> Field Officer
            </button>
            <button className={role === "public" ? "on" : ""} onClick={() => setRole("public")} data-testid="sender-role-public">
              <i className="fa-solid fa-users" /> Public
            </button>
          </div>

          <label className="field"><span>Your name</span>
            <input value={name} onChange={(e) => setName(e.target.value)} placeholder={role === "field" ? "Officer name" : "Your name"} data-testid="sender-name" />
          </label>
          <label className="field"><span>Message</span>
            <textarea rows={3} value={body} onChange={(e) => setBody(e.target.value)} placeholder="What's happening on the ground?" data-testid="sender-body" />
          </label>
          <div className="comms-actions">
            <label className="comms-urgent"><input type="checkbox" checked={urgent} onChange={(e) => setUrgent(e.target.checked)} /> Urgent</label>
            <button className="btn btn-primary" onClick={send} disabled={sending} data-testid="sender-send">
              <i className={`fa-solid ${sending ? "fa-spinner fa-spin" : "fa-paper-plane"}`} /> Send to Command
            </button>
          </div>

          <div className="sender-broadcasts">
            <div className="section-label"><i className="fa-solid fa-bullhorn" /> Latest from Command Centre</div>
            {broadcasts.length === 0 && <div className="rr-sub">No broadcasts yet.</div>}
            {broadcasts.slice(0, 5).map((b) => (
              <div key={b.id} className="sb-item" data-testid={`broadcast-${b.id}`}>
                {b.priority === "urgent" && <span className="chip chip-warn">URGENT</span>}
                <span>{b.body}</span>
                <em>→ {b.target === "public" ? "Public" : "Field"}</em>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SenderPage;
